<div class="subheader">
    <div class="caption-content">
        <h1 class="big-heading">
            {{title}}
        </h1>
        <p>{{caption}}</p>
    </div>
</div>
